import { ReactNode } from 'react';

import { Alert } from 'components/Display/Alert/Alert';

type Props = {
  children: ReactNode;
};

export const CustomContentPreset = ({ children }: Props) => (
  <Alert withoutIcon severity="error" fullWidth className="max-h-72 overflow-y-auto">
    <div className="flex w-full items-center justify-between">{children}</div>
  </Alert>
);
